export interface WebsiteTenant {
    id: string,
    subdomain: string,
    onpremises: boolean
}
export const tenants: WebsiteTenant[] = []
const createTenant = (id: string, subdomain: string, onpremises: boolean): WebsiteTenant => {
    const tenant: WebsiteTenant = { id, subdomain, onpremises }
    tenants.push(tenant)
    return tenant
}

const tenant_bfcoi = createTenant("", "bfcoi", true)
const tenant_fiducial = createTenant("", "fiducial", true)
const tenant_labanquepostale = createTenant("", "labanquepostale", true)
const tenant_sgba = createTenant("", "sgba", true)
const tenant_sgcb = createTenant("", "sgcb", true)
const tenant_sgpf = createTenant("", "sgpf", true)
const tenant_areas = createTenant("", "areas", false)
const tenant_els = createTenant("", "els", true) 
const tenant_malakoff = createTenant("", "malakoff", false) 

export interface WebsiteUser {
    login: string,
    firstname: string,
    lastname: string,
    tenant: WebsiteTenant
}

export const users: WebsiteUser[] = []
const createUser = (login: string, firstname: string, lastname: string, tenant: WebsiteTenant): WebsiteUser => {
    const user: WebsiteUser = { login, firstname, lastname, tenant }
    users.push(user)
    return user
}

createUser("s.just-ext@lefebvre-sarrut.eu", "Sébastien", "Just", tenant_els)
createUser("t.nguyen@efl.fr", "Thuy", "NGUYEN", tenant_els)
createUser("h.jouanet@efl.fr", "Hervé", "Jouanet", tenant_els)
createUser("jp.pittuelli@efl.fr", "Jean-Pierre", "Pituelli", tenant_els)
createUser("j.noel@lefebvre-sarrut.eu", "Julien", "Noel", tenant_els)
createUser("x.benard@lefebvre-sarrut.eu", "Xavier", "Benard", tenant_els)
createUser("m.cisse-ext@lefebvre-sarrut.eu", "Mamadou", "Cisse", tenant_els)
createUser("g.colavita@lefebvre-sarrut.eu", "Giuseppe", "COLAVITA", tenant_els)
createUser("s.galland@lefebvre-sarrut.eu", "Stéphanie", "Galland", tenant_els)
createUser("t.ginguene@lefebvre-sarrut.eu", "Thierry", "Ginguene", tenant_els)
createUser("p.heront@lefebvre-sarrut.eu", "Patrick", "Heront", tenant_els)
createUser("n.loza@lefebvre-sarrut.eu", "Nathalie", "Loza", tenant_els)
createUser("j.mehdi-ext@lefebvre-sarrut.eu", "Juba", "Mehdi", tenant_els)
createUser("g.njinwoua-ext@lefebvre-sarrut.eu", "Ghislain", "NJINWOUA", tenant_els)
createUser("t.lerichedessirier-ext@lefebvre-sarrut.eu", "Thierry", "LERICHE-DESSIRIER", tenant_els)

createUser("k.atchou@areas.fr", "Kossivi", "Atchou", tenant_areas)
createUser("p.bargel@areas.fr", "Philippe", "Bargel", tenant_areas)
createUser("g.bertrand@areas.fr", "Guillaume", "Bertrand", tenant_areas)
createUser("th.jamet@areas.fr", "Thomas", "Jamet", tenant_areas)
createUser("o.ragot@areas.fr", "Ragot", "Olivier", tenant_areas)
createUser("s.rouge@areas.fr", "Sylvain", "Rouge", tenant_areas)
createUser("p.dossantos@areas.fr", "Pascal", "Dos Santos", tenant_areas)

createUser("edson.ortega-exterieur@fiducial.net", "Edson", "Ortega", tenant_fiducial)
createUser("marie.lacour@fiducial.net", "Marie", "Lacour", tenant_fiducial)
createUser("matthieu.perrussel.morin@fiducial.net", "Matthieu", "Perrussel Morin", tenant_fiducial)

createUser("maria-angela.sanchez@labanquepostale.fr", "Maria-Angela", "Sanchez", tenant_labanquepostale)
createUser("vincent.bueno@labanquepostale.fr", "Vincent", "Bueno", tenant_labanquepostale)
createUser("jonathan.a.marty-prestataire@labanquepostale.fr", "Jonathan", "Marty", tenant_labanquepostale)
createUser("philippe.servantie@labanquepostale.fr", "Philippe", "Servantie", tenant_labanquepostale)
createUser("alexandre.pasquier-prestataire@labanquepostale.fr", "Alexandre", "Pasquier", tenant_labanquepostale)
createUser("thierry.coffin@labanquepostale.fr", "Thierry", "Coffin", tenant_labanquepostale)
createUser("sylvie.houbin-prestataire@labanquepostale.fr", "Sylvie", "Houbin", tenant_labanquepostale)
createUser("mathieu.keignaert-prestataire@labanquepostale.fr", "Mathieu", "Keignaert", tenant_labanquepostale)
createUser("alexandre.menneguerre@labanquepostale.fr", "Alexandre", "Menneguerre", tenant_labanquepostale)
createUser("sebastien.noal@labanquepostale.fr", "Sébastien", "Noal", tenant_labanquepostale)

createUser("julien.bachot-ext@malakoffhumanis.com", "Julien", "Bachot", tenant_malakoff)
createUser("francois.caron-ext@malakoffhumanis.com", "François", "Caron", tenant_malakoff)
createUser("cecile.grangeat@malakoffhumanis.com", "Cécile", "Grangeat", tenant_malakoff)
createUser("amine.nadif-ext@malakoffhumanis.com", "Amine", "Nadif", tenant_malakoff)
createUser("mamadou.niagate-ext@malakoffhumanis.com", "Mamadou", "Niagate", tenant_malakoff)
createUser("tanguy.pradels@malakoffhumanis.com", "Tanguy", "Pradels", tenant_malakoff)
createUser("melanie.quin@malakoffhumanis.com", "Melanie", "Quin", tenant_malakoff)
createUser("alioune.watt@malakoffhumanis.com", "Alioune", "Watt", tenant_malakoff)